// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import application from './application';
import AmountController from './amount_controller';
import BillController from './bill_controller';
import SignatureController from './signature_controller';
import InputmaskController from './inputmask_controller';
import PopulateyearController from './populateyear_controller';
import TomselectController from './tomselect_controller';
import TurboModalController from './turbo_modal_controller';

application.register('amount', AmountController);
application.register('bill', BillController);
application.register('signature', SignatureController);
application.register('inputmask', InputmaskController);
application.register('populateyear', PopulateyearController);
application.register('tomselect', TomselectController);
application.register('turbo-modal', TurboModalController);
